import { BasicClient } from '@/utils/httpClient'

export default class VismaIntegration {
  client: BasicClient
  constructor() {
    this.client = new BasicClient()
  }
  checkIntegrationVismaPeopleByType(type) {
    const param = {
      service_type: type
    }
    return this.client.exec('/externalapis/vismapeople/check', 'GET', param)
  }
  getCountries() {
    return this.client.exec('/externalapis/vismapeople/countries', 'GET')
  }
  getStates(idCountry) {
    return this.client.exec(
      `/externalapis/vismapeople/states/${idCountry}`,
      'GET'
    )
  }
  getCities(params) {
    return this.client.exec(
      `/externalapis/vismapeople/cities/${params.idCountry}/${params.idState}`,
      'GET'
    )
  }
  getMaritalstatus() {
    return this.client.exec('/externalapis/vismapeople/maritalstatus', 'GET')
  }
  getAddressTypes() {
    return this.client.exec('/externalapis/vismapeople/addresstypes', 'GET')
  }
  getNationalities() {
    return this.client.exec('/externalapis/vismapeople/nationalities', 'GET')
  }
  getVismaPeopleOrganizationModel() {
    return this.client.exec(
      '/externalapis/vismapeople/organizationmodels',
      'GET'
    )
  }
  getCounties(params) {
    return this.client.exec(
      `/externalapis/vismapeople/counties/${params.idState}`,
      'GET'
    )
  }
  getVia() {
    return this.client.exec('/externalapis/vismapeople/via', 'GET')
  }
  getZone() {
    return this.client.exec('/externalapis/vismapeople/zone-type', 'GET')
  }
  getPayrollStatus() {
    return this.client.exec('/externalapis/vismapeople/payroll/status', 'GET');
  }
  updatePayrollStatus(allowSalaryAdvance:boolean) {
    const status = allowSalaryAdvance ? 1 : 0;
    return this.client.exec('/externalapis/vismapeople/payroll/salary-advance/status', 'PATCH',  { activated: status })
  }
}
